import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteConfigurationButton: {
    defaultMessage: 'Delete this configuration',
    description: 'Device Elevator integration settings - delete button label',
    id: 'deleteConfigurationButton',
  },
});
